// Omnix/client/widgets/CampaignOverviewWidget.js
export default {
    name: "CampaignOverviewWidget",
    description: "Displays Campaign status and progress.",

    type: "DataWidget",
    roles: ["manager"],
    widget: {
        title: "Campaign Overview",
        dataProvider: {
            main: {
                rpc: "ManagerDashboardRpc.getCampaignOverview",
                transform: (response) => response?.data || []
            }
        },
        // --- IMPROVEMENT: A mini-dashboard card for each campaign ---
        itemTemplate: (item) => {
            const statusColors = {
                'running': 'primary', 'scheduled': 'info', 'completed': 'success', 'draft': 'secondary'
            };
            const statusColor = statusColors[item.status] || 'secondary';

            // Note: Assuming you can resolve the templateId to a channel type like 'SMS' or 'Email'.
            // For now, we'll placeholder it. In a real app, you might enrich this data.
            const campaignType = item.channelType || 'SMS'; // Placeholder
            const typeIcon = campaignType === 'SMS' ? 'bi-chat-text-fill' : 'bi-envelope-fill';

            const total = item.stats?.total || 0;
            const sent = item.stats?.sent || 0;
            const percentage = total > 0 ? Math.round((sent / total) * 100) : 0;

            return `
                <style>
                    .campaign-card {
                        padding: 0.75rem;
                        border-left: 4px solid var(--bs-${statusColor});
                        background-color: var(--bs-tertiary-bg);
                        border-radius: var(--bs-border-radius);
                        margin-bottom: 0.5rem;
                    }
                    .campaign-card .progress { height: 6px; }
                </style>
                <div class="campaign-card">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="fw-bold">${item.name}</div>
                        <span class="badge bg-${statusColor} text-capitalize">${item.status}</span>
                    </div>
                    <div class="text-muted small my-2">
                        <i class="bi ${typeIcon} me-1"></i> ${campaignType} Campaign
                    </div>
                    <div>
                        <div class="d-flex justify-content-between small text-muted">
                           <span>${sent.toLocaleString()} of ${total.toLocaleString()}</span>
                           <span>${percentage}%</span>
                        </div>
                        <div class="progress mt-1" role="progressbar">
                            <div class="progress-bar bg-${statusColor}" style="width: ${percentage}%"></div>
                        </div>
                    </div>
                </div>
            `;
        },
        noDataMessage: "No active or scheduled campaigns."
    }
};